// extracted by css-extract-rspack-plugin
export default {"container":"Content-module__container__RdWjX","pagination":"Content-module__pagination__tnR4R"};